module.exports = __webpack_public_path__ + "media/customizations/collective/logo-8e025881f0eb189a94ec1c7a6e353cf1.png";